import react from "react";
import { createComponent } from "@lit/react";
import { MdDivider } from "@material/web/divider/divider";

export const LitDivider = createComponent({
  tagName: "md-divider",
  elementClass: MdDivider,
  react
});
